/**
 * @generated SignedSource<<10f106eef61080a37b60e7583c0c8600>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentReadMoreButtonContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"appButtonContent">;
  readonly " $fragmentType": "contentReadMoreButtonContent";
};
export type contentReadMoreButtonContent$key = {
  readonly " $data"?: contentReadMoreButtonContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentReadMoreButtonContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentReadMoreButtonContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "appButtonContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "fbe60ac1753c05855997675c4e197128";

export default node;
